module.exports = __webpack_public_path__ + "static/media/MN.43f30b53.png";